module.exports = __webpack_public_path__ + "media/assets/images/blog/electrical_cabinet-5d5d267ca872a5e3c2d5cb59d185fcb1.jpeg";